
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface InstancesHeaderProps {
  onCreateInstance?: () => void;
  userRole?: string;
  showCreateButton?: boolean;
}

const InstancesHeader: React.FC<InstancesHeaderProps> = ({ 
  onCreateInstance, 
  userRole,
  showCreateButton = true
}) => {
  return (
    <div className="border-t-4 border-primary-blue pt-4 mb-8">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
        <div>
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">SaaS Instances</h1>
            {userRole && (
              <span className="ml-3 px-3 py-1 text-xs font-semibold text-white rounded-full bg-purple-600">
                {userRole.charAt(0).toUpperCase() + userRole.slice(1)}
              </span>
            )}
          </div>
          <p className="text-gray-600">Manage all your customer instances</p>
        </div>
        {showCreateButton && onCreateInstance && (
          <div className="mt-4 sm:mt-0">
            <Button 
              onClick={onCreateInstance} 
              className="flex items-center"
            >
              <Plus className="mr-2 h-4 w-4" />
              Create New Instance
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstancesHeader;
